var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useRecoilState } from 'recoil';
import { useRequest } from '../../hooks/useRequest';
import { flowsAtom, templatesAtom, voicesAtom, sttModelsAtom, llmModelsAtom } from '../store';
export var useFlows = function () {
    var request = useRequest();
    var _a = useRecoilState(flowsAtom), flows = _a[0], setFlows = _a[1];
    var _b = useRecoilState(voicesAtom), voices = _b[0], setVoices = _b[1];
    var _c = useRecoilState(sttModelsAtom), sttModels = _c[0], setSTTModels = _c[1];
    var _d = useRecoilState(llmModelsAtom), llmModels = _d[0], setLLMModels = _d[1];
    var _e = useRecoilState(templatesAtom), templates = _e[0], setTemplates = _e[1];
    var getFlows = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, request.get('/agents')];
                case 1:
                    data = (_a.sent()).data;
                    setFlows(data);
                    return [2 /*return*/, data];
                case 2:
                    error_1 = _a.sent();
                    console.log(error_1);
                    return [2 /*return*/, []]; // Return an empty array in case of error
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getVoices = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, request.get('/agents/voices')];
                case 1:
                    data = (_a.sent()).data;
                    setVoices(data);
                    return [2 /*return*/, data];
                case 2:
                    error_2 = _a.sent();
                    console.log(error_2);
                    return [2 /*return*/, []]; // Return an empty array in case of error
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getSTTModels = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, request.get('/agents/stt-models')];
                case 1:
                    data = (_a.sent()).data;
                    setSTTModels(data);
                    return [2 /*return*/, data];
                case 2:
                    error_3 = _a.sent();
                    console.log(error_3);
                    return [2 /*return*/, []]; // Return an empty array in case of error
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getLLMModels = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, request.get('/agents/llm-models')];
                case 1:
                    data = (_a.sent()).data;
                    setLLMModels(data);
                    return [2 /*return*/, data];
                case 2:
                    error_4 = _a.sent();
                    console.log(error_4);
                    return [2 /*return*/, []]; // Return an empty array in case of error
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getTemplates = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, request.get('/agents/templates')];
                case 1:
                    data = (_a.sent()).data;
                    data.unshift({
                        id: '',
                        name: "Blank",
                        flowDescription: "Start with a blank configuration if you are already familiar with Dowork.ai."
                    });
                    setTemplates(data);
                    return [2 /*return*/, data];
                case 2:
                    error_5 = _a.sent();
                    console.log(error_5);
                    return [2 /*return*/, []]; // Return an empty array in case of error
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var createNewFlow = function (templateFlowId) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request.post('/agents' + (templateFlowId != null ? "?templateFlowId=".concat(templateFlowId) : ''))];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    }); };
    var markAsTemplate = function (flowId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request.post("/agents/".concat(flowId, "/templates/mark"))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var unMarkAsTemplate = function (flowId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request.post("/agents/".concat(flowId, "/templates/unmark"))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var deleteFlow = function (flowId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request.delete("/agents/".concat(flowId, "/delete"))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var updateFlow = function (flow) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request.put('/agents', flow)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return { flows: flows, voices: voices, sttModels: sttModels, llmModels: llmModels, templates: templates, getFlows: getFlows, getVoices: getVoices, getSTTModels: getSTTModels, getLLMModels: getLLMModels, createNewFlow: createNewFlow, deleteFlow: deleteFlow, updateFlow: updateFlow, getTemplates: getTemplates, markAsTemplate: markAsTemplate, unMarkAsTemplate: unMarkAsTemplate };
};
